import { gql } from "@apollo/client";
import { ACFMediaFragment } from "@/fragments";
import { AdditionalFlexibleContentFragment, MediaFlexibleContentFragment } from "@/fragments/Ceremony";
import { EventFragment } from "@/fragments/Event";
import { PageDataFragment } from "@/fragments/PageData";

export const CeremonyLandingQuery = gql`
  ${ACFMediaFragment}
  ${EventFragment}
  ${MediaFlexibleContentFragment}
  ${AdditionalFlexibleContentFragment}
  ${PageDataFragment}
  query GetCeremonyLanding($databaseId: ID!, $asPreview: Boolean, $language: String!) {
    rhCeremony(id: $databaseId, asPreview: $asPreview, language: $language) {
      title
      uri
      slug
      ...PageData
      ceremonyLanding {
        featuredCeremony
        season
        useDefaultContent
        classYear {
          slug
        }
        featuredHero {
          contentType
          assetType
          headline
          body
          video
          videoThumbnail {
            ...ACFMedia
          }
          linkHero
          customCursorText
          heroLink {
            linkType
            externalLink
            page {
              node {
                uri
              }
            }
          }
          image {
            ...ACFMedia
          }
        }
        ...MediaFlexibleContent
        ...AdditionalFlexibleContent
      }
    }
  }
`;
